import { Add, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material';
import { PermissionLevel } from 'gleblu-socket-api';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import { PLACE_MENU_ITEM_ID, PLACE_SELECTION_MENU_ITEM_ID } from '@/constants/testIds';

import useTranslation from '../../components/hooks/useTranslation';
import { useOptionalPlaceContext } from '../../components/placeContext/usePlaceContext';
import Typography from '../../components/typography/Typography';
import { MANAGEMENT_URL, NEW_PLACE_SETUP_URL, PLACES } from '../../constants/RouterConstants';
import { getLoggedInUserSelector } from '../../store/selectors/authenticationSelectors';
import { authorizedPlaceNamesSelector } from '../../store/selectors/companySelectors';

interface Props {
  open: boolean;
  toggleOpen: () => void;
}

function PlaceSelectionMenu(props: Props) {
  const { open, toggleOpen } = props;
  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();
  const selectedPlace = useOptionalPlaceContext();
  const places = useSelector(authorizedPlaceNamesSelector);
  const placeUuid = selectedPlace ? selectedPlace.placeUuid : null;
  const selectedPlaceUniqueName = selectedPlace ? selectedPlace.uniqueName : '';
  const { companyPermission } = useSelector(getLoggedInUserSelector);
  const translatedStrings = useTranslation();
  return (
    <>
      <MenuItem onClick={toggleOpen} data-id={PLACE_SELECTION_MENU_ITEM_ID}>
        <ListItemText
          disableTypography
          primary={
            <Typography variant="subtitle1" color="inherit">
              {translatedStrings.placeLabel}
            </Typography>
          }
          secondary={
            placeUuid && (
              <Typography variant="caption" color="inherit">
                {places.find((placeState) => placeState.uuid === placeUuid)?.name ?? placeUuid}
              </Typography>
            )
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          {places.map((place, index) => (
            <MenuItem
              data-id={PLACE_MENU_ITEM_ID(index)}
              key={place.uuid}
              onClick={() => {
                if (placeUuid && match.url.includes(selectedPlaceUniqueName)) {
                  history.push(match.url.replace(selectedPlaceUniqueName, place.uniqueName) + location.search);
                } else {
                  history.push(`${PLACES}/${place.uniqueName}${MANAGEMENT_URL}`);
                }
              }}
              selected={place.uuid === placeUuid}
            >
              <ListItemText disableTypography inset primary={place.name} />
            </MenuItem>
          ))}
          {companyPermission === PermissionLevel.edit && (
            <MenuItem
              onClick={() => {
                history.push(NEW_PLACE_SETUP_URL);
              }}
            >
              <ListItemIcon>
                <Add />
              </ListItemIcon>
              <ListItemText disableTypography primary={translatedStrings.addNewPlaceMenuText} />
            </MenuItem>
          )}
        </MenuList>
      </Collapse>
    </>
  );
}

export default PlaceSelectionMenu;
